(() => {
  'use strict';

  const fields = ['title', 'product_type', 'tag', 'variants.sku'];
  const normalize = (value) => value.trim().slice(0, 160);
  const scopedQuery = (value) => {
    const terms = normalize(value).split(/\s+/).filter(Boolean);
    return terms.map((term, index) => {
      const escaped = term.replace(/[\\"]/g, '\\$&');
      const value = index === terms.length - 1 && /^[\p{L}\p{N}][\p{L}\p{N}_-]*$/u.test(term)
        ? `${term}*`
        : `"${escaped}"`;
      return `(${fields.map((field) => `${field}:${value}`).join(' OR ')})`;
    }).join(' AND ');
  };

  const params = new URLSearchParams(window.location.search);
  const displayTerm = params.get('search_term');
  const hasDisplayTerm = displayTerm !== null && params.get('q') === scopedQuery(displayTerm);

  if (hasDisplayTerm) {
    const currentUrl = new URL(window.location.href);
    document.querySelectorAll('.pagination a[href]').forEach((link) => {
      const targetUrl = new URL(link.href, currentUrl);
      if (targetUrl.origin !== currentUrl.origin || targetUrl.pathname !== currentUrl.pathname || targetUrl.searchParams.get('q') !== params.get('q')) return;
      targetUrl.searchParams.set('search_term', normalize(displayTerm));
      link.href = targetUrl.toString();
    });
  }

  document.querySelectorAll('form[data-material-search]').forEach((form) => {
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    if (form.hasAttribute('data-material-search-results') && hasDisplayTerm) {
      input.value = normalize(displayTerm);
    }

    form.addEventListener('formdata', (event) => {
      const term = normalize(input.value);
      if (!term) return;
      event.formData.set('q', scopedQuery(term));
      event.formData.set('search_term', term);
    });
  });
})();
